import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ServerErrorMessage } from '../../../../../../shared/utils/error';
import SumarigramaScreen from './screen';
import { SumarigramaAdapter, Sumarigrama, SumarigramaRequest } from '../../../../../../infraestructure/persistence/rest/SumarigramaAdapter';
import { useNotifications} from '../../../../../../shared/hooks/Notifications';

import { downloadFile } from '../../../../../../shared/utils/download';

export const SumarigramaContainer = (props:any) => {

	const api = new SumarigramaAdapter();
	const {menu, onlySearch, filter, onClickNode, style} = props;
	const {resultError, exceptionError, launchNotification} = useNotifications();
	let [ data, setData ] = useState<any>(undefined);
	let result: any;

	useEffect(() => {
		if(!menu && !filter){getSumarigrama()};
	}, []);

	useEffect(() => {
		filter && getSumarigramaUsuario(filter);
	}, [filter]);

	const getSumarigrama = async (version?: number) => {
		try {
			result = await api.Sumarigrama(version);
			
			if(result.data && result.data!=="")
			{
				setData({...result.data} || {});
				
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const getSumarigramaUsuario = async (filter: SumarigramaRequest) => {
		try {
			result = await api.SumarigramaUsuario(filter);
			
			if(result.data && result.data!=="")
			{
				setData({...result.data} || {});
				if(result.data.jerarquia.length > 0 && data === undefined) onClickNode(result.data.jerarquia[0].id);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const DescargarSumarigrama = async (data: any) => {
		// setIsLoading(true);
		try {
			result = await api.DescargarSumarigrama(data);
			if(result.data && result.data!=="")
			{
				downloadFile(result.data, 'Sumarigrama.xlsx');
			}else{resultError();}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
		// setIsLoading(false);
  	};
	
	return (
		<>
			<SumarigramaScreen menu={menu} onlySearch={onlySearch} data={data} handleFilter={getSumarigrama} onClickNode={onClickNode} style={style} onExport={DescargarSumarigrama}/>
		</>
	);
};

export default SumarigramaContainer;
